import { createContext, type PropsWithChildren, useContext } from 'react';

import type { IAlertsRepository } from '@/alerts/domain/repositories/alerts.repository';
import type { IActivityRepository } from '@/modules/documents/domain/repositories/activity.repository';
import type { IDocumentRepository } from '@/modules/documents/domain/repositories/document.repository';

import type { IAIRepository } from '../domain/repositories/ai-respository';
import type { IAlertNotificationRepository } from '../domain/repositories/alert-notification-respository';
import type { ICapacityEvaluationRepository } from '../domain/repositories/capacity-evaluation.repository';
import type { ISiteMetadataRepository } from '../domain/repositories/site-metadata.repository';
import type { ISiteRepository } from '../domain/repositories/site.repository';
import type { IVehicleRepository } from '../domain/repositories/vehicle.repository';

export type Dependencies = {
  repositories: {
    ai: IAIRepository;
    alertNotification: IAlertNotificationRepository;
    alerts: IAlertsRepository;
    capacityEvaluation: ICapacityEvaluationRepository;
    site: ISiteRepository;
    siteMetadata: ISiteMetadataRepository;
    vehicle: IVehicleRepository;
    documentActivity: IActivityRepository;
    document: IDocumentRepository;
  };
};

const DependenciesContext = createContext<Dependencies>(
  // @ts-expect-error - This is a placeholder value that should never be used
  null,
);

export function DependenciesProvider({
  children,
  dependencies,
}: PropsWithChildren<{
  dependencies: Dependencies;
}>) {
  return (
    <DependenciesContext.Provider value={dependencies}>
      {children}
    </DependenciesContext.Provider>
  );
}

export function useDependencies(): Dependencies {
  return useContext(DependenciesContext);
}
